'use client';
import { useState, useEffect } from 'react';
const shouldSerialize = (value) => {
    return typeof value === 'object' && value !== null;
};
function getStorageValue(key, defaultValue) {
    if (typeof window !== 'undefined') {
        const saved = sessionStorage.getItem(key);
        if (!saved)
            return defaultValue;
        try {
            return JSON.parse(saved);
        }
        catch (e) {
            return saved;
        }
    }
}
export const useSessionStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        return getStorageValue(key, defaultValue);
    });
    useEffect(() => {
        sessionStorage.setItem(key, shouldSerialize(value) ? JSON.stringify(value) : value);
    }, [key, value]);
    return [value, setValue];
};
